import React from 'react';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import { useLockControl } from 'features/toolbar/toolbar/controls/lock/useLockControl';

const LockControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const { triggerLockConfirmation, icon, label, isFeatureAvailable } = useLockControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onClick?.(event);
    triggerLockConfirmation();
  };

  return (
    <MobileMenuItem icon={icon} onClick={handleClick}>
      {label}
    </MobileMenuItem>
  );
};

export default LockControlMobile;
